module.exports = __webpack_public_path__ + "img/mobile-logo.75c7266b.webp";